import { useContext } from 'react';
import { IntegrationsContext } from '@/contexts/IntegrationsContext';

/**
 * Hook for accessing integrations context
 */
export function useIntegrations() {
  const context = useContext(IntegrationsContext);

  if (!context) {
    throw new Error('useIntegrations must be used within IntegrationsProvider');
  }

  return context;
}
